export default __webpack_public_path__ + "static/media/Refined Philtre of Constitution.31a3df07.jpg";